// We intentionally treat pending as verified and we move it to 'Denied'
// if there is a failed call attempt with this number
export const getVerificationStatusText = (status) => {
  switch (status) {
    case "VERIFIED":
    case "PENDING": // This is intentional
      return "Verified";
    case "DENIED":
      return "Denied";
    default:
      return "Unknown";
  }
};

export const getVerificationStatusColor = (status) => {
  switch (status) {
    case "VERIFIED":
    case "PENDING": // This is intentional
      return "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300";
    case "DENIED":
      return "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300";
    default:
      return "bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-300";
  }
};
